/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateStateRequestViewModel } from "../types/CreateStateRequestViewModel.ts";

export const createStateRequestViewModelSchema = z.object({
  code: z.string().nullish(),
  name: z.string().nullish(),
  abbreviation: z.string().nullish(),
  countryId: z.optional(z.number().int()),
}) as unknown as ToZod<CreateStateRequestViewModel>;
